import client from '@/apis/http-client'
import Vue from 'vue'
import qs from 'qs'

const useMockData = false
const resource = 'agent-privileges'

const mockInsurancePartners = [
  { id: 'ins-1', name_en: 'AIA Thailand', name_th: 'เอไอเอ ประเทศไทย' },
  { id: 'ins-2', name_en: 'Bangkok Insurance', name_th: 'บางกอกประกันภัย' }
]

const mockSource = [
  {
    id: 'ap-1',
    org_codename: 'psuv',
    insurance_partner_id: 'ins-1',
    insurance_partner_name: 'AIA Thailand',
    title_th: 'ส่วนลดตรวจสุขภาพ 20%',
    title_en: 'Health Check Discount 20%',
    description_th: 'ส่วนลดแพ็กเกจตรวจสุขภาพประจำปี',
    description_en: 'Applies to annual check-up packages',
    valid_from: '2026-09-01',
    valid_to: '2026-12-31',
    updated_at: '2026-09-30T09:00:00Z'
  },
  {
    id: 'ap-2',
    org_codename: 'pchb',
    insurance_partner_id: 'ins-1',
    insurance_partner_name: 'AIA Thailand',
    title_th: 'อัปเกรดห้องฟรี',
    title_en: 'Free Room Upgrade',
    description_th: 'อัปเกรดห้องระดับ 1 สำหรับสมาชิก AIA',
    description_en: '1-tier room upgrade for AIA members',
    valid_from: '2026-06-01',
    valid_to: '2026-08-31',
    updated_at: '2026-09-20T09:00:00Z'
  },
  {
    id: 'ap-3',
    org_codename: 'psuv',
    insurance_partner_id: 'ins-2',
    insurance_partner_name: 'Bangkok Insurance',
    title_th: 'คืนเงินแพ็กเกจสุขภาพ',
    title_en: 'Wellness Package Cashback',
    description_th: 'คืนเงิน 5% สำหรับแพ็กเกจสุขภาพ',
    description_en: '5% cashback on wellness packages',
    valid_from: '2026-07-15',
    valid_to: '2026-10-15',
    updated_at: '2026-09-18T09:00:00Z'
  }
]

const defaultState = () => ({
  currentPage: 1,
  pageSize: 10,
  total: 0,
  sortBy: 'updated_at',
  sortDesc: 'DESC',
  textSearch: '',
  filterOrgCode: '',
  filterInsurancePartnerId: '',
  list: [],
  isLoading: false,
  isSaving: false,
  orgOptions: [],
  insurancePartnerOptions: []
})

const state = defaultState()
const generateMockId = (prefix) => `${prefix}-${Date.now()}-${Math.floor(Math.random() * 100000)}`

const actions = {
  setResource() {},
  resetList({commit}) { commit('RESET_LIST_STATE') },
  setTextSearch({commit}, text) { commit('SET_TEXT_SEARCH', text) },
  setFilterOrgCode({commit}, orgCode) { commit('SET_FILTER_ORG_CODE', orgCode) },
  setFilterInsurancePartnerId({commit}, partnerId) { commit('SET_FILTER_INSURANCE_PARTNER_ID', partnerId) },
  async fetchOrgOptions({commit}) {
    if (useMockData) {
      commit('SET_ORG_OPTIONS', [
        {text: 'psuv - Princ Suvarnabhumi', value: 'psuv'},
        {text: 'pchb - Princ Chonburi', value: 'pchb'},
        {text: 'ppnp - Princ Pak Nam Pho', value: 'ppnp'}
      ])
      return
    }
    try {
      const response = await client.secureHttpClient.get('/por/api/organization/permission?permission=View&category=Organization')
      const data = response?.data?.data || response?.data || []
      commit('SET_ORG_OPTIONS', (data || []).map((item) => {
        const codename = String(item.codename || item.value || '').toLowerCase()
        const name = item.name || item.name_th || item.text || codename.toUpperCase()
        return { text: `${codename} - ${name}`, value: codename }
      }).filter(item => item.value))
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_ORG_OPTIONS', [])
    }
  },
  async fetchInsurancePartnerOptions({commit}) {
    if (useMockData) {
      commit('SET_INSURANCE_PARTNER_OPTIONS', mockInsurancePartners.map((item) => ({
        text: item.name_en || item.name_th || item.id,
        value: item.id
      })))
      return
    }

    try {
      const response = await client.secureHttpClient.get('/por/api/insurance-partners', {
        params: { page: 1, limit: 500, orderBy: 'updated_at', sort: 'DESC' },
        paramsSerializer: localParams => qs.stringify(localParams, {encode: false})
      })
      const resData = response?.data || {}
      const list = resData.results || resData.data || []
      commit('SET_INSURANCE_PARTNER_OPTIONS', (Array.isArray(list) ? list : []).map(item => ({
        text: item.name_en || item.name_th,
        value: item.id
      })))
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_INSURANCE_PARTNER_OPTIONS', [])
    }
  },
  async fetch({commit, state}) {
    commit('SET_IS_LOADING', true)
    if (useMockData) {
      let data = [...mockSource]
      if (state.filterOrgCode) data = data.filter(item => item.org_codename === state.filterOrgCode)
      if (state.filterInsurancePartnerId) data = data.filter(item => item.insurance_partner_id === state.filterInsurancePartnerId)
      if (state.textSearch) {
        const term = state.textSearch.toLowerCase()
        data = data.filter(item => `${item.title_th || ''} ${item.title_en || ''} ${item.description_th || ''} ${item.description_en || ''}`.toLowerCase().includes(term))
      }
      commit('SET_LIST', data)
      commit('SET_TOTAL', data.length)
      commit('SET_IS_LOADING', false)
      return
    }

    try {
      const response = await client.secureHttpClient.get(`/por/api/${resource}`, {
        params: {
          page: state.currentPage,
          limit: state.pageSize,
          orderBy: state.sortBy,
          sort: state.sortDesc,
          search: state.textSearch,
          org_codename: state.filterOrgCode,
          insurance_partner_id: state.filterInsurancePartnerId
        },
        paramsSerializer: localParams => qs.stringify(localParams, {encode: false})
      })

      const resData = response?.data || {}
      const list = resData.results || resData.data || []
      const total = resData.total !== undefined ? resData.total : list.length
      commit('SET_LIST', Array.isArray(list) ? list : [])
      commit('SET_TOTAL', total)
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_LIST', [])
      commit('SET_TOTAL', 0)
    }

    commit('SET_IS_LOADING', false)
  },
  async save({commit, state}, payload) {
    commit('SET_IS_SAVING', true)
    if (useMockData) {
      const partner = state.insurancePartnerOptions.find(item => item.value === payload.insurance_partner_id)
      const normalized = {
        ...payload,
        insurance_partner_name: partner ? partner.text : (payload.insurance_partner_name || '')
      }
      if (payload.id) {
        const index = mockSource.findIndex(item => item.id === payload.id)
        if (index !== -1) mockSource[index] = {...mockSource[index], ...normalized, updated_at: new Date().toISOString()}
      } else {
        mockSource.unshift({...normalized, id: generateMockId('ap'), updated_at: new Date().toISOString()})
      }
      commit('SET_IS_SAVING', false)
      return {ok: true, message: ''}
    }

    try {
      if (payload.id) await client.secureHttpClient.put(`/por/api/${resource}/${payload.id}`, payload)
      else await client.secureHttpClient.post(`/por/api/${resource}`, payload)
      commit('SET_IS_SAVING', false)
      return {ok: true, message: ''}
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_IS_SAVING', false)
      return {ok: false, message: e?.response?.data?.message || 'Unable to save'}
    }
  },
  async deleteById(_context, id) {
    if (useMockData) {
      const index = mockSource.findIndex(item => item.id === id)
      if (index !== -1) mockSource.splice(index, 1)
      return true
    }
    try {
      await client.secureHttpClient.delete(`/por/api/${resource}/${id}`)
      return true
    } catch (e) {
      Vue.$log.error(e)
      return false
    }
  }
}

const mutations = {
  RESET_LIST_STATE(state) {
    state.currentPage = 1
    state.pageSize = 10
    state.total = 0
    state.sortBy = 'updated_at'
    state.sortDesc = 'DESC'
    state.textSearch = ''
    state.filterOrgCode = ''
    state.filterInsurancePartnerId = ''
    state.list = []
  },
  SET_TEXT_SEARCH(state, text) { state.textSearch = text },
  SET_FILTER_ORG_CODE(state, orgCode) { state.filterOrgCode = orgCode },
  SET_FILTER_INSURANCE_PARTNER_ID(state, partnerId) { state.filterInsurancePartnerId = partnerId },
  SET_LIST(state, list) { state.list = list },
  SET_TOTAL(state, total) { state.total = total },
  SET_IS_LOADING(state, isLoading) { state.isLoading = isLoading },
  SET_IS_SAVING(state, isSaving) { state.isSaving = isSaving },
  SET_ORG_OPTIONS(state, orgOptions) { state.orgOptions = orgOptions },
  SET_INSURANCE_PARTNER_OPTIONS(state, insurancePartnerOptions) { state.insurancePartnerOptions = insurancePartnerOptions }
}

export default { namespaced: true, state, actions, mutations }
